//import { PATHS } from 'Utils/PagePaths';
import { PublicAccordion } from 'Components/Public/Accordion/PublicAccordion';
import { Row, Col } from 'react-bootstrap';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import LaunchIcon from '@mui/icons-material/Launch';

export const DATA_SECURITY_DATA = [
  {
    title: "Our Commitment to Privacy & Security",
    level: 1,
    content:
      <>
        <p>PSOPPC is built on a foundation of trust, accountability, and compliance. We follow best practices in:</p>
        <ul>
          <li><strong>End-to-End Encryption</strong>: Patient Safety Event (PSE) reports are encrypted in transit and in storage.</li>
          <li><strong>Strict Access Controls</strong>: Identity verification and role-based permissions to protect data.</li>
          <li><strong>Proactive Security</strong>: Routine audits, security checks, and penetration testing.</li>
          <li><strong>Full Regulatory Compliance</strong>: We strictly adhere to the Patient Safety Rule, HIPAA, HITECH, and NIST standards.</li>
        </ul>
      </>,
  },
  {
    title: "Data Governance",
    size: "lg",
    level: 1,
    content:
      <>
        {/**Visable on lg and xl */}
        <Row className='d-none d-lg-block d-xl-block'>
          <Col className='mt-2 d-flex flex-nowrap'>
            <div className="data-handling-card-both d-inline-flex justify-content-center align-items-center">
              <span className='ms-2 me-2'>PSO Submits Data</span>
            </div>
            <ArrowCircleRightIcon fontSize='large' className="ms-3 me-3 mt-4"></ArrowCircleRightIcon>
            <div className="data-handling-card-both  d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Validates Data</div>
            </div>
            <ArrowCircleRightIcon fontSize='large' className="m-0 ms-3 me-3 mt-4"></ArrowCircleRightIcon>
            <div className="data-handling-card-left d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC De-itentifies Data</div>
            </div>
            <ArrowCircleRightIcon fontSize='large' className="m-0 ms-3 me-3 mt-4"></ArrowCircleRightIcon>
            <div className="data-handling-card-left d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Shares Data with NPSD</div>
            </div>
          </Col>
        </Row>
        {/**Visable on md */}
        <Row className='d-none d-md-block d-lg-none'>
          <Col className='mt-2 d-flex flex-nowrap'>
            <div className="data-handling-card-both d-inline-flex justify-content-center align-items-center">
              <span className='ms-2 me-2'>PSO Submits Data</span>
            </div>
            <ArrowCircleRightIcon fontSize='large' className="ms-3 me-3 mt-4"></ArrowCircleRightIcon>
            <div className="data-handling-card-both  d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Validates Data</div>
            </div>
            <ArrowCircleRightIcon fontSize='large' className="m-0 ms-3 me-3 mt-4"></ArrowCircleRightIcon>
          </Col>
        </Row>
        <Row className='mt-3 d-none d-md-block d-lg-none'>
          <Col className='mt-2 d-flex flex-nowrap'>
            <div className="data-handling-card-left d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC De-itentifies Data</div>
            </div>
            <ArrowCircleRightIcon fontSize='large' className="m-0 ms-3 me-3 mt-4"></ArrowCircleRightIcon>
            <div className="data-handling-card-left d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Shares Data with NPSD</div>
            </div>
          </Col>
        </Row>
        {/**Visable on sm */}
        <Row className='mb-2 text-center d-none d-sm-block d-md-none'>
          <Col>
            <div className="data-handling-card-both d-inline-flex justify-content-center align-items-center">
              <span className='ms-2 me-2'>PSO Submits Data</span>
            </div>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-none d-sm-block d-md-none'>
          <Col>
            <ArrowCircleDownIcon fontSize='large'></ArrowCircleDownIcon>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-none d-sm-block d-md-none'>
          <Col className=''>
            <div className="data-handling-card-both d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Validates Data</div>
            </div>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-none d-sm-block d-md-none'>
          <Col>
            <ArrowCircleDownIcon fontSize='large'></ArrowCircleDownIcon>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-none d-sm-block d-md-none'>
          <Col>
            <div className="data-handling-card-left  d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC De-itentifies Data</div>
            </div>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-none d-sm-block d-md-none'>
          <Col className=''>
            <ArrowCircleDownIcon fontSize='large'></ArrowCircleDownIcon>
          </Col>
        </Row>
        <Row className='text-center d-none d-sm-block d-md-none'>
          <Col>
            <div className="data-handling-card-left  d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Shares Data with NPSD</div>
            </div>
          </Col>
        </Row>
        {/**Visable on xs */}
        <Row className='mb-2 text-center d-block d-sm-none'>
          <Col>
            <div className="data-handling-card-both d-inline-flex justify-content-center align-items-center">
              <span className='ms-2 me-2'>PSO Submits Data</span>
            </div>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-block d-sm-none'>
          <Col>
            <ArrowCircleDownIcon fontSize='large'></ArrowCircleDownIcon>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-block d-sm-none'>
          <Col className=''>
            <div className="data-handling-card-both d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Validates Data</div>
            </div>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-block d-sm-none'>
          <Col>
            <ArrowCircleDownIcon fontSize='large'></ArrowCircleDownIcon>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-block d-sm-none'>
          <Col>
            <div className="data-handling-card-left d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC De-itentifies Data</div>
            </div>
          </Col>
        </Row>
        <Row className='mb-2 text-center d-block d-sm-none'>
          <Col className=''>
            <ArrowCircleDownIcon fontSize='large'></ArrowCircleDownIcon>
          </Col>
        </Row>
        <Row className='text-center d-block d-sm-none'>
          <Col>
            <div className="data-handling-card-left d-inline-flex justify-content-center align-items-center">
              <div className='ms-2 me-2'>PSOPPC Shares Data with NPSD</div>
            </div>
          </Col>
        </Row>
        {/**Description */}
        <Row className='mt-3'>
          <Col>
            <div><div class='d-inline-flex box-card-light-blue'></div>&nbsp;Test Data</div>
            <div><div class='d-inline-flex box-card-dark-blue'></div>&nbsp;Production Data</div>
          </Col>
        </Row>
      </>,
  },
  /*
  {
    title: "Our Recommendations",
    level: 1,
    content:
      <>
        <p>
          For a smooth data submission, the PSOPPC highly encourages PSOs to:
        </p>
        <ul>
          <li>
            Submit test data first to confirm the structure of your data will be accepted. You will have the option to delete any test data you submit to the PSOPPC.
          </li>
          <li>
            Internally de-identify raw data before submitting production data.
          </li>
          <li>
            Avoid including PII/PHI in optional narrative fields.
          </li>
        </ul>
        <p>PSOs are encouraged to review the <a href={PATHS.public['Submit Data']}>Submit Data</a> page.</p>
      </>,
  },
  */
  {
    title: "De-identification Process",
    level: 1,
    content:
      <>
        <p>To learn more about the federal standards that guide our de-identification process, visit the HHS&nbsp;<a className="help-external-link" href="https://www.hhs.gov/hipaa/for-professionals/special-topics/de-identification/index.html" target="_blank">HIPAA Privacy Rule: Methods for De-identification<LaunchIcon className="ms-1"></LaunchIcon></a></p>
        <p>
          <ol type="1">
            <li>Removal of patient DOB, neonate DOB, and age (replaced with age category)</li>
            <li>Conversion of event/report dates to year and quarter</li>
            <li>Exclusion of PSO IDs and pseudo provider IDs</li>
            <li>Suppression of specific data elements (e.g., Record Id, Submission Date, Type of NQF serious reportable event, etc.)</li>
            <li>Omission of identifying information in free-form text fields.</li>
          </ol>
        </p>
      </>,
  },
  {
    title: "FAQ & Resources",
    level: 1,
    content:
      <>
        <p>Below is a list of frequently asked questions (FAQ).</p>
        <PublicAccordion
          defaultActiveKey={[]}
          accordionItemsContent={[
            {
              header: "Will the data I submit be shared with CMS or any other government entities?",
              content: () => {
                return (
                  <>
                    <p>
                      No, data submitted to the PSOPPC on behalf of your PSO is not shared with CMS or any other government agencies; instead, the PSOPPC de-identifies the data and securely transmits it to the NPSD to support national patient safety learning and improvement.
                    </p>
                  </>
                )
              }
            },
            {
              header: "Will the data I submit be used to benchmark my PSO against other submitters?",
              content: () => {
                return (
                  <>
                    <p className="mb-0">
                      No, the PSOPPC does not develop benchmark rates or benchmark prevalence and your data is not used for benchmarking. As a PSO that submits patient safety event data, you can login to the secure pages of the PSOPPC website to view your PSO’s data in interactive dashboards and compare your event volume trends and incident rate trends to national aggregates via the Comparative National Dashboard (CND).
                    </p>
                  </>
                )
              }
            },
            {
              header: "What safeguards prevent re-identification of my PSO or members in trends published by the NPSD?",
              content: () => {
                return (
                  <>
                    <p className="mb-0">
                      The PSOPPC applies rigorous de-identification protocols before transmission to the NPSD, including:
                    </p>
                    <ul className='accordion-list-style'>
                      <li>
                        Removal of patient DOB, neonate DOB, and age (replaced with age category)
                      </li>
                      <li>
                        Conversion of event/report dates to year and quarter
                      </li>
                      <li>
                        Exclusion of PSO IDs and pseudo provider IDs
                      </li>
                      <li>
                        Suppression of specific data elements (e.g., Record Id, Submission Date, Type of NQF serious reportable event, etc.)
                      </li>
                      <li>
                        Omission of identifying information in free-form text fields
                      </li>
                    </ul>
                    <p>
                      All Patient Safety Work Product (PSWP) is handled securely and in compliance with HIPAA. The NPSD infrastructure
                      and data suppression rules ensure that re-identification of PSOs, providers, or patients is not possible.
                    </p>
                  </>
                )
              }
            },
            {
              header: "How much data does the PSOPPC receive and how often?",
              content: () => {
                return (
                  <>
                    <p>
                      Submission volume and frequency vary by PSO. By 2025, the NPSD contains approximately 4 million patient safety event reports, with submissions occurring weekly, monthly, quarterly, or annually, depending on each PSO’s reporting structure.
                    </p>
                    <p>
                      While some PSOs contribute larger volumes of data, the PSOPPC employs robust, federally mandated safeguards to ensure that no PSO—regardless of submission size—can be re-identified. These protections apply consistently across all submissions and are designed to maintain strict confidentiality and data integrity within the national system.
                    </p>
                  </>
                )
              }
            },
            {
              header: "Are the data points used in the PSOPPC Tableau interface the same ones used in the NPSD Chartbooks?",
              content: () => {
                return (
                  <>
                    <p>
                      The Tableau interface for PSOs and the public-facing NPSD Chartbooks both utilize PSO-submitted data, but they serve different purposes and are presented differently:
                    </p>
                    <p>
                      1. PSOPPC Tableau Dashboards:
                    </p>
                    <ul className='accordion-list-style'>
                      <li>
                        These include the Clinical Dashboard and the Comparative National Dashboard.
                      </li>
                      <li>
                        They display data distributions specific to the submitting PSO and comparisons to other PSOs in aggregate.
                      </li>
                      <li>
                        Designed for internal PSO use.
                      </li>
                    </ul>
                    <p>
                      2. NPSD Chartbooks and Dashboards:
                    </p>
                    <ul className='accordion-list-style'>
                      <li>
                        Intended for a broader, public audience.
                      </li>
                      <li>
                        Data is aggregated across all PSOs.
                      </li>
                      <li>
                        Certain sensitive data is omitted or further aggregated (e.g., residual harm, rare age groups) to reduce the risk of identifying individual cases, in compliance with non-identification requirements.
                      </li>
                    </ul>
                  </>
                )
              }
            },
            {
              header: "When the PSOPPC performs AI-based free-text analysis, how are identifiers removed?",
              content: () => {
                return (
                  <>
                    <p>
                      Our number one priority is protecting the identities of patients, providers, and reporters. When submitting data to PSOPPC, we ask that PSOs assign unique Provider IDs to their member providers so information can’t be tracked back to an individual or facility. Also, prior to analysis, all submitted free-text data undergoes a de-identification process to eliminate personally identifiable information (PII), including the replacement of names, addresses, and dates with standardized placeholders (e.g., “NAME,” “ADDRESS,” “DATE”).
                    </p>
                    <p>
                      This process ensures that the data used for AI free-text analysis remains fully anonymized and adheres to strict privacy and confidentiality standards.
                    </p>
                  </>
                )
              }
            },
          ]}
        ></PublicAccordion>
      </>,
  },
]